
interface ApiSettings {
	name: string;
	url: string;
	withCredentials: boolean;
}

interface AppSettings {
	apiSetting: ApiSettings;
}

let urlToAPI = "";
//Selon l'environnement on indique l'url de base des API
//@ts-ignore
urlToAPI = import.meta.env.VITE_BASE_URL;
//Paramètres de base pour Axios

const settings: AppSettings = {
	apiSetting: {
		name: "local-api",
		url: urlToAPI, //@ts-ignore
		withCredentials: import.meta.env.VITE_API_WITHCREDENTIALS,
	},
};

export default settings;
